import { getStylePropertyValueFromDOM } from '@/Utils/StylesUtility';
import Config from '@/Config';

export const cardBrands = {
    MasterCard: 'mc',
    Visa: 'visa',
    Amex: 'amex',
    Maestro: 'maestro',
    Diners: 'diners',
    JCB: 'jcb',
    Discover: 'discover',
    Cartebancaire: 'cartebancaire',
};

export const defaultCardNetworks = Config.paymentProviders.adyen.availableCardBrands;

export const cardStyles = {
    base: {
        fontFamily: getStylePropertyValueFromDOM('--adyen-font-family'),
        fontSize: getStylePropertyValueFromDOM('--adyen-sdk-text-body-font-size'),
        lineHeight: getStylePropertyValueFromDOM('--adyen-sdk-text-body-line-height'),
        padding: '0',
        color: getStylePropertyValueFromDOM('--adyen-sdk-color-label-primary'),
        background: getStylePropertyValueFromDOM('--adyen-sdk-color-background-primary'),
    },
    error: {
        color: getStylePropertyValueFromDOM('--adyen-sdk-color-label-primary'),
    },
    focus: {
        color: getStylePropertyValueFromDOM('--adyen-sdk-color-label-primary'),
    },
    valid: {
        color: getStylePropertyValueFromDOM('--adyen-sdk-color-label-primary'),
    },
    placeholder: {
        color: getStylePropertyValueFromDOM('--adyen-sdk-color-label-placeholder'),
        opacity: 0.6,
    },
};